import { MarketPeriodInterface } from 'features/dispatcher/dispatcherTypes';

// ==============================|| MILESTONES TRACKING UTILS ||============================== //

export const MILESTONES_TRACKING_TICK = 1000; // 1 second

export enum MarketDayEventEnum {
  MARKET_DAY_SECOND_CHANGED = 'MarketDaySecondChanged',
  MARKET_DAY_HALF_MINUTE_CHANGED = 'MarketDayHalfMinuteChanged',
  MARKET_DAY_MINUTE_CHANGED = 'MarketDayMinuteChanged',
  MARKET_DAY_PERIOD_CHANGED = 'MarketDayPeriodChanged',
  MARKET_DAY_HOUR_CHANGED = 'MarketDayHourChanged',
  MARKET_DAY_CHANGED = 'MarketDayChanged'
}

export interface EventDetail {
  currentMarketTimestamp: Date;
  currentMarketPeriod: MarketPeriodInterface | undefined;
  currentMarketHour: MarketPeriodInterface | undefined;
  currentMarketDay: string;
}

export interface UseMarketDayMilestonesTrackingListenersProps {
  onSecondChanged?: (detail: EventDetail) => void;
  onHalfMinuteChanged?: (detail: EventDetail) => void;
  onMinuteChanged?: (detail: EventDetail) => void;
  onPeriodChanged?: (detail: EventDetail) => void;
  onHourChanged?: (detail: EventDetail) => void;
  onDayChanged?: (detail: EventDetail) => void;
  onInitializeListener?: (detail: EventDetail) => void;
}
